export default __webpack_public_path__ + "static/media/CapaDownloadTheApp.0b7d1dbc.png";